import React from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Grid,
  Header,
  Icon,
  Segment
} from "semantic-ui-react";
import "./dashboard.styles.scss";

type MenuItem = {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  url: string;
};

// Menu items based on admin.layout.tsx
const menuItems: MenuItem[] = [
  {
    icon: <Icon name="barcode" size="large" />,
    title: "Баркод",
    subtitle: "Бар кодоор барааны үлдэгдэл нэмэх",
    url: "/provider/shelf"
  },
  {
    icon: <Icon name="box" size="large" />,
    title: "Бүтээгдэхүүн",
    subtitle: "Бүтээгдэхүүний жагсаалт болон тохируулга",
    url: "/provider/warehouse"
  },
  {
    icon: <Icon name="box" size="large" />,
    title: "Шинэ бүтээгдэхүүн",
    subtitle: "Шинэ бүтээгдэхүүн нэмэх",
    url: "/provider/products/new"
  },
  {
    icon: <Icon name="user" size="large" />,
    title: "Бүртгэл",
    subtitle: "Нийлүүлэгчийн бүртгэл",
    url: "/provider/account"
  },
]

class ProviderDashboard extends React.Component {
  render() {
    return (
      <Container className='dashboard-page'>
        <Grid columns={3} stackable className='dashboard-sections'>
          {menuItems.map((section, idx) => (
            <Grid.Column key={idx}>
              <Link to={section.url} style={{ textDecoration: 'none' }}>
                <Segment className='dashboard-section' textAlign='center' style={{ cursor: 'pointer' }}>
                  <div className='dashboard-section-icon'>
                    {section.icon}
                  </div>
                  <Header className='dashboard-section-title'>
                    {section.title}
                  </Header>
                  <div className='dashboard-section-subtitle'>
                    {section.subtitle}
                  </div>
                </Segment>
              </Link>
            </Grid.Column>
          ))}
        </Grid>
      </Container>
    );
  }
}

export default ProviderDashboard;
